import React from 'react';

import { usePatientFormTemplatePaginationV2 } from 'ui-model';

import { PatientFormTemplateType } from '@lib/resources/types';

import FilterSearchHeader from '../FilterSearchHeader';

import FilterPatientFormTemplateData from './FilterPatientFormTemplateData';

interface FilterPatientFormTemplateProps {
  formType?: PatientFormTemplateType[];
  multiSelect?: boolean;
}

const FilterPatientFormTemplate: React.FC<FilterPatientFormTemplateProps> = (props) => {
  const { formType = ['ccda', 'intake'], multiSelect = true } = props;
  const [searchQuery, setSearchQuery] = React.useState('');

  const paginationResult = usePatientFormTemplatePaginationV2({
    limit: 20,
    _select: 'title',
    _sort: 'title:asc',
    lumabot: false,
    type: formType.join(','),
    title: searchQuery ? `${searchQuery}*` : undefined,
  });

  return (
    <React.Fragment>
      <FilterSearchHeader onSearchChange={setSearchQuery} />
      <FilterPatientFormTemplateData multiSelect={multiSelect} {...paginationResult} />
    </React.Fragment>
  );
};

export default FilterPatientFormTemplate;
